export const TIPO_PROGRAMACAO_DIARIA_FOLGA = "213aa79b-0ce2-4b45-9c55-ae20ec5c5ea1";
export const TIPO_PROGRAMACAO_DIARIA_INSPECAO = "213aa79b-0ce2-4b45-9c55-ae20ec5c5ea2";
export const TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO = "213aa79b-0ce2-4b45-9c55-ae20ec5c5ea3";
export const TIPO_PROGRAMACAO_DIARIA_SUCATA = "213aa79b-0ce2-4b45-9c55-ae20ec5c5ea4";
export const TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS = "213aa79b-0ce2-4b45-9c55-ae20ec5c5ea5";
export const TIPO_PROGRAMACAO_DIARIA_OUTROS = "213aa79b-0ce2-4b45-9c55-ae20ec5c5ea6";
